<template>
  <div class="fancy-feature-ten pt-100" id="why">
    <div class="container">
      <div class="row justify-content-between align-items-center">
        <div class="col-xl-7 col-lg-10 col-md-8 m-auto">
          <div class="title-style-six text-center">
            <h2>{{ $t('why.title') }}</h2>
          </div>
        </div>
      </div>

      <div class="row justify-content-center mt-35 md-mt-20">
        <div
            v-for="item in fancyFeatureData"
            :key="item.id"
            class="col-lg-4 col-md-6 card-container"
            data-aos="fade-up"
            data-aos-duration="1200"
            :data-aos-delay="item.delay"
        >
          <div class="card">
            <div class="icon">
              <img :src="item.icon" alt="" />
            </div>
            <h3>{{ $t(`why.items.${item.id}.title`) }}</h3>
            <p>{{ $t(`why.items.${item.id}.subtitle`) }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "SaasInfraWhy",
  data() {
    return {
      fancyFeatureData: [
        {
          id: 1,
          icon: require(`@/assets/images/icon/106-c.svg`),
          delay: "",
        },
        {
          id: 2,
          icon: require(`@/assets/images/icon/79-c.svg`),
          delay: "100",
        },
        {
          id: 3,
          icon: require(`@/assets/images/icon/romb-c.svg`),
          delay: "200",
        },
      ],
    };
  },
};

</script>

<style scoped>
/* Title spacing */
h2 {
  margin-bottom: 30px;
}

/* Make all cards the same height */
.card {
  background-color: #f5f5f5;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  display: flex;
  flex-direction: column;
  height: 100%; /* Ensures all cards are equal height */
}

.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

/* Ensure the text inside the card fills space properly */
h3 {
  font-size: 1.25rem;
  color: #333;
  margin-bottom: 10px;
}

p {
  color: #777;
  line-height: 1.5;
  font-size: 0.95rem;
  flex-grow: 1; /* Ensures text expands to fill space */
}

/* Spacer to push elements to balance height */
.spacer {
  margin-top: auto; /* Pushes content up if text is short */
}

/* Icon styling */
.icon {
  width: 50px;
  height: 50px;
  margin-bottom: 15px;
}

/* Responsive spacing */
.card-container {
  margin-bottom: 30px;
}

@media (max-width: 768px) {
  .card-container {
    margin-bottom: 40px;
  }
}
</style>
